<section>
    <article></article>
    <article class="body">
        <div class="--icon">
            <figure>
                <img src="assets/media/screens/warning/icon.svg" alt="icon" loading="lazy">
            </figure>
        </div>
        <div class="--info">
            <p>{{routing?.title}}</p>
            <ng-container *ngIf="routing?.subtitle">
                <p style="font-weight: 700;">
                    {{routing?.subtitle}}
                </p>
            </ng-container>
        </div>
        <div class="--footer" *ngIf="!!routing?.action">
            <button class="df-primario df-btn-xl" (click)="onSubmit(button.id)" *ngFor="let button of routing?.action">{{button.label}}</button>
        </div>
    </article>
    <article></article>
</section>